import _regeneratorRuntime from "D:\\new-code\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import FileList from "@/modules/stu/components/FileList";
export default {
  name: "MemberArrangeItem",
  components: {
    FileList: FileList
  },
  props: {
    type: {
      type: Number
    },
    item: {
      type: Object,
      default: function _default() {}
    },
    arrange_type: {
      default: ""
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      remark: "",
      readonly: false,
      title: "",
      fileList: [],
      show: false,
      debounceSetShow: this.$pub.debounce(this.setShow, 100)
    };
  },
  computed: {
    times_status: function times_status() {
      if (this.item.times_status) {
        return this.item.times_status;
      }

      var ts = parseInt(new Date().getTime() / 1000);

      if (ts < this.item.start_play) {
        return 1;
      } else if (ts >= this.item.start_play && ts <= this.item.end_play) {
        return 2;
      }

      return 3;
    }
  },
  methods: {
    setShow: function setShow(val) {
      this.show = val;
    },
    getLiveRoom: function () {
      var _getLiveRoom = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(type, arrange_id) {
        var data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$http.get("/api/app/getPcRoomCode/course_id=0/chapter_id=0", {
                  type: type,
                  arrange_id: arrange_id
                });

              case 2:
                data = _context.sent;
                return _context.abrupt("return", data.chapterInfo);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getLiveRoom(_x, _x2) {
        return _getLiveRoom.apply(this, arguments);
      }

      return getLiveRoom;
    }(),
    onPlay: function () {
      var _onPlay = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this = this;

        var type, arrange_id, _this$$router$resolve, href, liveData, _this$$router$resolve2, _href;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                type = this.type == 1 ? 4 : 3;
                arrange_id = this.item.id || this.item.arrange_id;
                _this$$router$resolve = this.$router.resolve({
                  name: "Live",
                  query: {
                    course_id: 0,
                    period_id: 0,
                    type: type,
                    course_type: 2,
                    arrange_id: arrange_id
                  }
                }), href = _this$$router$resolve.href;

                if (!(this.$store.state.commonSetting.client_download_on == 0)) {
                  _context3.next = 7;
                  break;
                }

                document.location = href;
                _context3.next = 15;
                break;

              case 7:
                if (!(this.$store.state.commonSetting.client_download_on == 1)) {
                  _context3.next = 14;
                  break;
                }

                _context3.next = 10;
                return this.getLiveRoom(type, arrange_id);

              case 10:
                liveData = _context3.sent;

                if (liveData.client_url) {
                  _this$$router$resolve2 = this.$router.resolve({
                    name: "DownloadClient",
                    query: {
                      url: liveData.client_url
                    }
                  }), _href = _this$$router$resolve2.href;
                  document.location = _href;
                } else {
                  document.location = href;
                }

                _context3.next = 15;
                break;

              case 14:
                if (this.$store.state.commonSetting.client_download_on == 2) {
                  this.$courseExtension.openLiveSelect({
                    webHandler: function webHandler() {
                      document.location = href;
                    },
                    clientHandler: function () {
                      var _clientHandler = _asyncToGenerator(
                      /*#__PURE__*/
                      _regeneratorRuntime.mark(function _callee2() {
                        var liveData;
                        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                          while (1) {
                            switch (_context2.prev = _context2.next) {
                              case 0:
                                _context2.next = 2;
                                return _this.getLiveRoom(type, arrange_id);

                              case 2:
                                liveData = _context2.sent;

                                if (liveData.client_url) {
                                  _this.$services.LiveService.openClient(liveData.client_url);
                                } else {
                                  document.location = href;
                                }

                              case 4:
                              case "end":
                                return _context2.stop();
                            }
                          }
                        }, _callee2);
                      }));

                      function clientHandler() {
                        return _clientHandler.apply(this, arguments);
                      }

                      return clientHandler;
                    }()
                  });
                }

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onPlay() {
        return _onPlay.apply(this, arguments);
      }

      return onPlay;
    }(),
    onLeave: function () {
      var _onLeave = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.$promiseConfirm("请假后不能取消，确认请假吗？", {
                  customClass: "confirm-simple"
                });

              case 2:
                _context4.next = 4;
                return this.$http.post("/api/app/arrange/leave", {
                  type: this.type,
                  student_times_id: this.item.student_times_id
                });

              case 4:
                this.$emit("leave");
                this.$success("请假成功");

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function onLeave() {
        return _onLeave.apply(this, arguments);
      }

      return onLeave;
    }(),
    onComment: function onComment() {
      if (this.item.s_remark) {
        this.readonly = true;
        this.remark = this.item.s_remark;
        this.title = "查看评价";
      } else {
        this.readonly = false;
        this.remark = "";
        this.title = "课次评价";
      }

      this.dialogVisible = true;
    },
    onSubmitComment: function () {
      var _onSubmitComment = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this.readonly) {
                  _context5.next = 3;
                  break;
                }

                this.dialogVisible = false;
                return _context5.abrupt("return");

              case 3:
                if (this.remark) {
                  _context5.next = 5;
                  break;
                }

                return _context5.abrupt("return", this.$info("请输入评价内容"));

              case 5:
                _context5.next = 7;
                return this.$http.post("/api/app/arrange/evaluate", {
                  type: this.type,
                  student_times_id: this.item.student_times_id,
                  s_remark: this.remark
                });

              case 7:
                this.item.s_remark = this.remark;
                this.dialogVisible = false;
                this.$success("评价成功");

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function onSubmitComment() {
        return _onSubmitComment.apply(this, arguments);
      }

      return onSubmitComment;
    }(),
    onTeacherComment: function onTeacherComment() {
      this.title = "查看老师评价";
      this.readonly = true;
      this.remark = this.item.t_remark;
      this.dialogVisible = true;
    },
    onCommunication: function onCommunication(item) {
      this.$router.push({
        name: "PeriodsMemberOtoCommunication",
        query: {
          id: item.id
        }
      });
    },
    onDownload: function onDownload(item) {
      window.open(item.notes_url);
    }
  }
};